import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import goldImg from "../../../../assets/imgs/services/nationals/gold-background.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import "../shared-css/national-global-styles.css";
import NationalDescription from "../../../../components/national-description/national-description";
import gold1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Gold01.svg"
import gold2Icon from "../../../../assets/imgs/services/nationals/gold-icons/Gold02.svg"
import gold3Icon from "../../../../assets/imgs/services/nationals/gold-icons/Gold03.svg"
import condiciones1Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones01.svg"
import condiciones2Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones02.svg"
import condiciones3Icon from "../../../../assets/imgs/services/nationals/gold-icons/Condiciones03.svg"

function Gold() {
  const [tGold] = useTranslation("goldPage");
  const [tSMetaData] = useTranslation("metaData");
  const idGold = "a84034f2-01c6-417f-b05b-267a81f27c06";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[0]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[0]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(`${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idGold}`, {
        headers: {
          Authorization: process.env.REACT_APP_PUBLIC_KEY,
        },
      })
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Embalaje y Manejo Especial"]
              .content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Packaging and Special Handling"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("gold.title")}</title>
        <meta name="description" content={tSMetaData("gold.description")} />
      </Helmet>

      <ImageHeader
        imgBackground={goldImg}
      />

      <div className="info-national-content">
        <NationalDescription 
          title={tGold("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tGold("header.quote-btn")}
          quoteProductID="btnQuoteGold"
          contactSales={tGold("header.contact-sales")}
          contactProductID="btnContactGold"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tGold("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tGold("accordion-1.title")}
              content={
                accordion1
                  ? JSON.parse(accordion1) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tGold("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tGold("accordion-3.title")}
              content={
                accordion3
                  ? JSON.parse(accordion3) : "{}"
              }
            />
          </div>
          
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tGold("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={gold1Icon} /></div>
              <p>{tGold("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={gold2Icon} /></div>
              <p>{tGold("non-applicable-charges.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={gold3Icon} /></div>
              <p>{tGold("non-applicable-charges.item3")}</p>
            </div>
          </div>
        </div>

        <div className="more-info-box">
          <h5>{tGold("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={condiciones1Icon} /></div>
              <p>{tGold("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={condiciones2Icon} /></div>
              <p>{tGold("additional-conditions.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={condiciones3Icon} /></div>
              <p>{tGold("additional-conditions.item3")}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Gold;